export default __webpack_public_path__ + "static/char-s-02-jp-634a3e351323c6634b78a31fe1a06eed.png";